module.exports = __webpack_public_path__ + "static/media/DINOT-Bold.42a2a456.woff";